import React from 'react';
import {
  FaWhatsapp,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

const socialLinks = [
  {
    name: "WhatsApp",
    icon: <FaWhatsapp />,
    url: "https://wa.me/918433711334",
    color: "bg-green-500 hover:bg-green-600",
  },
  {
    name: "Instagram",
    icon: <FaInstagram />,
    url: "https://www.instagram.com/brionenterprises.in/",
    color:
      "bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:opacity-90",
  },
  {
    name: "Facebook",
    icon: <FaFacebookF />,
    url: "https://www.facebook.com/profile.php?id=61591606966051",
    color: "bg-blue-600 hover:bg-blue-700",
  },
  {
    name: "LinkedIn",
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/company/brionenterprises/",
    color: "bg-blue-700 hover:bg-blue-800",
  },
];

export default function FloatingSocials() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.name}
          className={`${social.color} w-8 h-8 rounded-full flex items-center justify-center text-white text-xl shadow-lg transition-all duration-300 hover:scale-110`}
        >
          {social.icon}
        </a>
      ))}
    </div>
  );
}